import React, { FC } from "react";
import { SkeletonWrapper } from "./Skeleton.styles";

interface SkeletonProps {
  width?: string;
  height?: string;
  borderRadius?: string;
  className?: string;
}

const Skeleton: FC<SkeletonProps> = ({
  width = "100%",
  height = "1rem",
  borderRadius = "0.25rem",
  className,
}) => (
  <SkeletonWrapper
    $width={width}
    $height={height}
    $borderRadius={borderRadius}
    className={className}
  />
);

export default React.memo(Skeleton);
